'use strict';

const jQuery = require('jquery');

const DesignRepository = require('./../../../../bundles/content/repository/DesignRepository');

const FormBuilder = require('./../../builder');

let ElementClass = require('./../../elementClass');

FormBuilder.register('font', function(config) {
    let self = {};
    let $select;

    self = new ElementClass(config);

    self.render = function($wrap) {
        let $element = jQuery('<div class="cloud-control cloud-select"/>');
        let $label;

        $select = jQuery('<select/>');

        if (self.label) {
            $label = jQuery('<label/>');

            if (self.labelClass) {
                $label.addClass(self.labelClass);
            }

            $label.text(self.label);
            $wrap.append($label);
        }

        if (self.elementClass) {
            $select.addClass(self.elementClass);
        }

        DesignRepository.getFonts().done((fonts) => {
            fonts.forEach((font) => {
                let $option = jQuery('<option/>');

                $option.val(font.value);
                $option.text(font.label);

                if (self.value === font.value) {
                    $option.attr('selected', true);
                }

                $select.append($option);
            });
        });

        return $element.append($select);
    };

    self.getData = function() {
        return $select.find('option:selected').val();
    };

    return self;
});
